import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { ILaboratoryStudents } from "./routeType";

import type { IPickDelete } from "@/api";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import { useGetAllMemberLaboratoryStudents } from "@/api/members/laboratories/students/getAll";
import { useGetMemberLaboratoryStudent } from "@/api/members/laboratories/students/get";

const { getPath } = getApi("members.laboratories.students.delete");

type IExtractedRouteType = ILaboratoryStudents["laboratoryStudentSingleDelete"];

export type IDeleteMemberLaboratoryStudent = IPickDelete<IExtractedRouteType>;

const deleteMemberLaboratoryStudent: MutationFunction<
  IDeleteMemberLaboratoryStudent["response"],
  IDeleteMemberLaboratoryStudent["variables"]
> = ({ labId, studentId }) => {
  return axiosClient.delete(getPath({ labId, studentId }));
};

export const useDeleteMemberLaboratoryStudent = createMutation({
  mutationFn: deleteMemberLaboratoryStudent,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratoryStudents.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratoryStudent.getKey({ labId }),
    });
  },
});
